export default {
  allow_all: "allow_all",
  asset_common_view: "asset_common_view",
  asset_common_manage: "asset_common_manage",
  asset_view: "asset_view",
  asset_manage: "asset_manage",
  contract_view: "contract_view",
  contract_manage: "contract_manage",
  customer_view: "customer_view",
  customer_manage: "customer_manage",
  admin_view: "admin_view",
  deployment_view: "deployment_view",
  deployment_manage: "deployment_manage",
  event_view: "event_view",
  event_components_manage: "event_components_manage",
  event_manage: "event_manage",
  graphicset_view: "graphicset_view",
  graphicset_manage: "graphicset_manage",
  mixer_manage: "mixer_manage",
  recording_view: "recording_view",
  roomtemplate_view: "roomtemplate_view",
  roomtemplate_manage: "roomtemplate_manage",
  scoped_by_customer_view: "scoped_by_customer_view",
  source_view: "source_view",
  source_view_advanced: "source_view_advanced",
  source_manage: "source_manage",
  user_view: "user_view",
  user_manage: "user_manage",
};
